<template>
  <div>
    <v-row class="mt-3">
      <v-col>
        <v-menu
          ref="datePicker"
          v-model="datePicker"
          :close-on-content-click="false"
          :return-value.sync="date"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="date"
              :label="dateLabel"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              class="ma-0 pa-0"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="date"
            no-title
            scrollable
            first-day-of-week="1"
            locale="es-ES"
            @input="$refs.datePicker.save(date)"
          >
          </v-date-picker>
        </v-menu>
      </v-col>
      <v-col>
        <v-menu
          ref="hourPicker"
          v-model="hourPicker"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="hour"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="hour"
              :label="hourLabel"
              prepend-icon="mdi-clock-time-four-outline"
              readonly
              v-bind="attrs"
              v-on="on"
              class="ma-0 pa-0"
            ></v-text-field>
          </template>
          <v-time-picker
            v-if="hourPicker"
            format="24hr"
            v-model="hour"
            full-width
            @click:minute="$refs.hourPicker.save(hour)"
          ></v-time-picker>
        </v-menu>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    dateLabel: String,
    hourLabel: String,
    type: Number,
  },

  data() {
    return {
      datePicker: false,
      hourPicker: false,
      date: "",
      hour: "00:00",
    };
  },

  methods: {
    ...mapActions("utils", ["setInitDateFilter", "setEndDateFilter"]),

    padZero(value) {
      return value < 10 ? `0${value}` : value;
    },
  },

  mounted() {
    // const today = new Date();
    // if (this.type == 1) {
    //   this.hour = `00:00`;
    //   this.date = `${today.getFullYear()}-${this.padZero(today.getMonth() + 1)}-${this.padZero(today.getDate())}`;
    //   // this.setInitDateFilter(this.date + " " + this.hour);
    // } else {
    //   this.hour = `23:59`;
    //   this.date = `${today.getFullYear()}-${this.padZero(today.getMonth() + 1)}-${this.padZero(today.getDate())}`;
    //   this.setEndDateFilter(this.date + " " + this.hour);
    // }
  },

  watch: {
    datePicker() {
      if (this.date.length > 0 && this.hour.length > 0) {
        const payload = this.date + " " + this.hour;
        this.$emit("cambio", payload);
        // this.type == 1 ? this.setInitDateFilter(this.date + " " + this.hour) : this.setEndDateFilter(this.date + " " + this.hour);
      }
    },

    hourPicker() {
      if (this.date.length > 0 && this.hour.length > 0) {
        const payload = this.date + " " + this.hour;
        this.$emit("cambio", payload);
        // this.type == 1 ? this.setInitDateFilter(this.date + " " + this.hour) : this.setEndDateFilter(this.date + " " + this.hour);
      }
    },
  },
};
</script>
:
